import Essential from "../../assets/Images/companyName.svg";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import Header from "../../component/Header";
import FooterComponent from "../../component/Footer";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { BsEye } from "react-icons/bs";
import { useSelector, useDispatch } from "react-redux";
import { useFetchData } from "../../hooks/useFtechData";
import { 
  APPLICATION_API,
  INTERVIEW_API,
  JOB_URL,
  EMAILJS_SERVICE_ID,
  EMAILJS_TEMPLATE_ID,
  EMAILJS_PRIVATE_KEY, 
} from "../../resources/resource";
import axios from "axios";
import PDFPreviewModal from "../../component/pdf/CvPreview";
import { useMakeRequest } from "../../hooks/useMakeRequest";
import { Spinner } from "flowbite-react";
import { toast } from "sonner";
import emailjs from "@emailjs/browser"; // Import EmailJS (commented out if not used)

function ApplicantionStatus() {
  const [currentApplicant, setCurrentApplicant] = useState(0);
  const { jobId } = useParams();
  const [loading, setLoading] = useState(false);
  const currentUserDetails = useSelector((state) => state.user.currentUser);
  const currentApplication = useSelector(
    (state) => state.currentApplication.currentApplication
  );
  const currentUserId = currentUserDetails?._id || "";
  const makeRequest = useMakeRequest();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [interviewData, setInterviewData] = useState({
    job: jobId,
    additionalInformation: "N/A",
    questions: [],
  });

  const [formData, setFormData] = useState({
    status: "Rejected",
    customMessage: "",
    reasonForRejection: "",
  });

  const [notificationData, setNotificationData] = useState({
    sender: currentUserId,
    message: "Sorry",
  });

  const [jobDetails, setJobDetails] = useState({});
  const [applications, setApplications] = useState([]);
  const [appResponse, setAppResponse] = useState("Rejected");
  const [allApplicant, setAllApplicant] = useState([]);

  const {
    data,
    loading: dataLoading,
    refetch,
  } = useFetchData(JOB_URL + `/getAJob/${jobId}`);
  const {
    data: applicationData,
    loading: applicationLoading,
    refetch: applicationRefetch,
  } = useFetchData(APPLICATION_API + `/getApplicationByJobId/${jobId}`);

  const handleSelect = (newIndex) => {
    setCurrentApplicant(newIndex);
    setInterviewData({
      ...interviewData,
      application: currentApplication[currentApplicant]?._id,
    });
  };

  const sendSMS = async (recipientPhone, message) => {
    setLoading(true);
    try {
      const applicant = data?.numberOfApplicant[currentApplicant];
      if (!applicant || !applicant.phoneNumber) {
        toast.error('Applicant phone number not available', {
          style: { background: 'white', color: 'black' },
        });
        return;
      }
      let phone = applicant.phoneNumber?.trim();
      console.log(phone, "your phone");
      if (!phone) throw new Error('Phone number is required');
      if (phone.startsWith('0')) phone = '+234' + phone.slice(1);

      const apiKey = process.env.REACT_APP_KUDI_API_KEY || 'your-api-key';
      const senderId = process.env.REACT_APP_KUDI_SENDER_I || 'E-JOB';
      const gateway = process.env.REACT_APP_KUDI_GATEWAY || 'https://sms-gateway.example.com/api/sms';

      if (!apiKey || !senderId || !gateway) throw new Error('Missing SMS API configuration');
      if (!message || message.trim() === '') throw new Error('Message content is empty');

      let smsMessage = message.trim().replace(/\s+/g, ' ').replace(/2025/g, '25');
      smsMessage = smsMessage.replace(/\[LETTERHEAD_IMAGE\]/g, '').replace(/<img[^>]*>/g, '').trim();
      smsMessage = smsMessage.substring(0, 160);

      const response = await axios.post(
        gateway,
        { token: apiKey, senderID: senderId, recipients: phone, message: smsMessage },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.status === 'success') {
        toast.success('SMS sent successfully', { style: { background: '#16a34a', color: 'white' } });
      } else {
        throw new Error(response.data.msg || 'Failed to send SMS');
      }
    } catch (error) {
      console.error('Error sending SMS:', error.message, error.response?.data);
      toast.error(error.message || 'Failed to send SMS', { style: { background: '#D33636', color: 'white' } });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const applicationId = data?.applications[currentApplicant]?._id;
    const applicantPhone = data?.numberOfApplicant[currentApplicant]?.phone;

    try {
      if (appResponse === "Scheduled") {
        setInterviewData({
          ...interviewData,
          application: data?.applications[currentApplicant]?._id,
        });
        makeRequest(
          INTERVIEW_API + `/createInterview`,
          "POST",
          interviewData,
          (data) => {
            refetch();
            const interviewDetails = `Interview Scheduled:\nType: ${interviewData.typeOfInterview || "N/A"}\nDate: ${interviewData.interviewDate || "N/A"}\nTime: ${interviewData.interviewTime || "N/A"}\n${formData.customMessage || "We look forward to seeing you!"}`;
            sendSMS(applicantPhone, interviewDetails);
          },
          (error) => {
            console.log(error);
          },
          () => {
            console.log();
          }
        );
      } else if (appResponse === "Rejected") {
        const rejectionMessage = `Application Rejected:\nReason: ${formData.reasonForRejection || "No reason provided"}\n${formData.customMessage || "We regret to inform you."}`;
        sendSMS(applicantPhone, rejectionMessage);
      }

      makeRequest(
        APPLICATION_API + `/updateApplication/${applicationId}`,
        "PUT",
        formData,
        () => {
          refetch();
        },
        (error) => {
          console.log(error);
        },
        () => {
          setLoading(false);
        }
      );
    } catch (error) {
      console.error("Error updating application:", error);
    }
  };

  function InterviewQuestions({ interviewId }) {
    const { data, loading } = useFetchData(`${INTERVIEW_API}/getAnInterview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ interviewId })
    });

    if (loading) return <Spinner />;
    if (!data?.data?.questions) return null;

    return (
      <div className="space-y-4">
        {data.data.questions.map((q, index) => (
          <div key={index}>
            <h3 className="capitalize mb-2">{q.question}</h3>
            <span className="block p-2 border bg-gray-200 rounded-lg">
              {q.response || "No response yet"}
            </span>
          </div>
        ))}
      </div>
    );
  }

  const handleResponse = (value) => {
    if (value === "Rejected") {
      setNotificationData((prevNotify) => ({
        ...prevNotify,
        message: "Sorry",
        recipient: data?.numberOfApplicant[currentApplicant]._id,
        application: data?.applications[currentApplicant]._id,
      }));
    } else {
      setNotificationData((prevNotify) => ({
        ...prevNotify,
        message: "Congratulations",
        recipient: data?.numberOfApplicant[currentApplicant]?._id,
        application: data?.applications[currentApplicant]._id,
      }));
      setFormData((prevData) => ({ ...prevData, reasonForRejection: null }));
    }
    setFormData((prevData) => ({ ...prevData, status: value }));
    setAppResponse(value);
  };

  const handleReason = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, [e.target.name]: value });
  };

  const handleCustomMessage = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, customMessage: value });
  };

  const handleInterviewData = (key, value) => {
    setInterviewData({ ...interviewData, [key]: value });
  };

  const addQuestion = () => {
    setInterviewData({
      ...interviewData,
      questions: [...interviewData.questions, ""]
    });
  };

  const updateQuestion = (index, value) => {
    const updatedQuestions = [...interviewData.questions];
    updatedQuestions[index] = value;
    setInterviewData({ ...interviewData, questions: updatedQuestions });
  };

  const removeQuestion = (index) => {
    setInterviewData({
      ...interviewData,
      questions: interviewData.questions.filter((_, i) => i !== index)
    });
  };

  // Predefined questions
  const predefinedQuestions = [
    "Who do you live with?",
    "Are you flexible to relocate?",
    "How much is your transport fare to and from the interview location?",
    "What are your immediate responsibilities?",
    "How soon are you willing to start work?",
    "What is your expected salary?",
    "Do you have any prior experience?",
  ];

  const [usePredefined, setUsePredefined] = useState(false);
  const [selectedPredefined, setSelectedPredefined] = useState([]);

  const handlePredefinedChange = (e) => {
    const question = e.target.value;
    setSelectedPredefined((prev) =>
      prev.includes(question)
        ? prev.filter((q) => q !== question)
        : [...prev, question]
    );
  };

  const handleUsePredefinedChange = (e) => {
    const checked = e.target.checked;
    setUsePredefined(checked);
    if (checked) {
      setInterviewData({
        ...interviewData,
        questions: selectedPredefined.map((q) => ({ question: q, response: "" })),
      });
    } else {
      setSelectedPredefined([]);
      setInterviewData({ ...interviewData, questions: [] });
    }
  };

  return (
    <div className="container mx-auto p-4 text-sm pt-16 sm:pt-20">
      <Header darkMode={true} />
      <div className="flex flex-col md:flex-row md:space-x-6">
        <div className="md:w-3/5 p-4 border rounded-lg bg-white shadow-lg">
          <div className="flex justify-between items-center mb-4">
            <img
              className="w-40"
              src={data?.employer?.avatar || Essential}
              alt="company logo"
            />
          </div>

          <h1 className="text-2xl font-semibold mb-2">{jobDetails.jobTitle}</h1>
          <p className="text-gray-600">{data?.employerName}</p>
          <p className="text-gray-600 mb-4">{data?.state}</p>

          <div className="mb-4">
            <h3 className="font-medium">Job Details</h3>
            <div className="mt-2">
              <span className="px-2 py-1 bg-gray-200 rounded-2xl mr-2">
                {data?.jobType}
              </span>
              <span className="px-2 py-1 bg-gray-200 rounded-2xl">
                {data?.salary}
              </span>
            </div>
            <div className="pt-4">
              <p>{data?.jobSummary}</p>
            </div>
            <div className="mt-4 bg-gray-100 p-4 rounded-lg">
              <ul className="list-disc pl-4">
                {data?.jobDescription
                  ? data.jobDescription.map((eachDescription, index) => (
                      <li key={index}>{eachDescription}</li>
                    ))
                  : null}
              </ul>
            </div>
          </div>

          <div className="my-6">
            <h3 className="text-xl font-semibold mb-2">
              Why should we hire you
            </h3>
            <div className="border p-3 rounded-lg bg-gray-50">
              <span className="block text-gray-500 mb-2">Cover Letter</span>
              <p>{data?.applications[currentApplicant]?.coverLetter || ""}</p>
            </div>
          </div>

          <div className="flex flex-col space-y-4 w-full">
            {data?.additionalInterviewQuestion &&
              data?.applications[
                currentApplicant
              ].additionalQuestionResponse.map((eachResponse, index) => (
                <div className="w-full" key={index}>
                  <h3 className="capitalize mb-2">{eachResponse.question}</h3>
                  <span className="block p-2 border bg-gray-200 rounded-lg">
                    {eachResponse.response}
                  </span>
                </div>
              ))}
          </div>

          <div className="my-4">
            <h2 className="text-lg font-semibold mb-2">Resume/CV</h2>
            <button
              onClick={() => {
                setIsModalOpen(true);
              }}
              className="flex items-center p-2 rounded bg-gray-400 text-white w-full justify-between"
            >
              {data?.applications[currentApplicant]?.resume?.split(";")[0] ||
                ""}
              <BsEye />
            </button>
          </div>

          <div className="flex justify-between">
            <button
              onClick={() => {
                handleResponse("Rejected");
              }}
              className={`w-1/2 px-4 py-2 border rounded-l-lg ${
                appResponse === "Rejected"
                  ? "bg-orange-500 text-white border-orange-400"
                  : "bg-white text-gray-500 border-gray-300"
              }`}
            >
              Reject
            </button>
            <button
              onClick={() => {
                handleResponse("Scheduled");
              }}
              className={`w-1/2 px-4 py-2 border rounded-r-lg ${
                appResponse === "Scheduled"
                  ? "bg-orange-500 text-white border-orange-400"
                  : "bg-white text-gray-500 border-gray-300"
              }`}
            >
              Set for interview
            </button>
          </div>
          {appResponse === "Rejected" && (
            <div className="my-4">
              <form action="">
                <label className="block mb-2 text-sm text-gray-500">
                  Reason for rejection
                </label>
                <textarea
                  name="reasonForRejection"
                  value={formData.reasonForRejection}
                  onChange={handleReason}
                  className="w-full p-2 border rounded-lg"
                />
                <label className="block mb-2 text-sm text-gray-500 mt-4">
                  Custom Rejection Message
                </label>
                <textarea
                  name="customMessage"
                  value={formData.customMessage}
                  onChange={handleCustomMessage}
                  className="w-full p-2 border rounded-lg"
                  placeholder="Enter custom message for the applicant..."
                />
                <button
                  onClick={handleSubmit}
                  className="px-6 py-2 bg-orange-500 text-white rounded-lg mt-4"
                >
                  Submit
                </button>
              </form>
            </div>
          )}
          {appResponse === "Scheduled" && (
            <div className="p-4 border rounded-lg bg-white shadow-lg mt-6">
              <h2 className="text-lg font-semibold mb-4">
                Schedule an Interview
              </h2>
              <form onSubmit={handleSubmit}>
                <div className="space-y-4">
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm text-gray-500">
                      Interview Type
                    </label>
                    <select
                      value={interviewData.typeOfInterview}
                      onChange={(e) =>
                        handleInterviewData("typeOfInterview", e.target.value)
                      }
                      className="border rounded-lg p-2"
                    >
                      <option value="">Select Interview Type</option>
                      <option value="Physical">Physical</option>
                      <option value="Virtual">Virtual</option>
                    </select>
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm text-gray-500">
                      Location
                    </label>
                    <input
                      type="text"
                      value={interviewData.interviewLocation}
                      onChange={(e) =>
                        handleInterviewData(
                          "interviewLocation",
                          e.target.value
                        )
                      }
                      className="border rounded-lg p-2"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm text-gray-500">Date</label>
                    <input
                      type="date"
                      value={interviewData.interviewDate}
                      onChange={(e) =>
                        handleInterviewData("interviewDate", e.target.value)
                      }
                      className="border rounded-lg p-2"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm text-gray-500">Time</label>
                    <input
                      type="time"
                      value={interviewData.interviewTime}
                      onChange={(e) =>
                        handleInterviewData("interviewTime", e.target.value)
                      }
                      className="border rounded-lg p-2"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm text-gray-500">
                      Additional Information
                    </label>
                    <input
                      type="text"
                      value={interviewData.additionalInformation}
                      onChange={(e) =>
                        handleInterviewData(
                          "additionalInformation",
                          e.target.value
                        )
                      }
                      className="border rounded-lg p-2"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="mb-2 text-sm text-gray-500">
                      Interview Questions
                    </label>
                    <div className="mb-2">
                      <label>
                        <input
                          type="radio"
                          name="questionType"
                          checked={usePredefined}
                          onChange={handleUsePredefinedChange}
                        /> Use Predefined Questions
                      </label>
                      <label className="ml-4">
                        <input
                          type="radio"
                          name="questionType"
                          checked={!usePredefined}
                          onChange={() => setUsePredefined(false)}
                        /> Use Custom Questions
                      </label>
                    </div>
                    {usePredefined ? (
                      <div className="space-y-2">
                        {predefinedQuestions.map((question) => (
                          <label key={question} className="flex items-center">
                            <input
                              type="checkbox"
                              value={question}
                              checked={selectedPredefined.includes(question)}
                              onChange={handlePredefinedChange}
                            />
                            <span className="ml-2">{question}</span>
                          </label>
                        ))}
                      </div>
                    ) : (
                      <>
                        {interviewData.questions.map((question, index) => (
                          <div key={index} className="flex mb-2">
                            <input
                              type="text"
                              value={question}
                              onChange={(e) => updateQuestion(index, e.target.value)}
                              className="border rounded-lg p-2 flex-grow"
                              placeholder={`Question ${index + 1}`}
                            />
                            <button
                              type="button"
                              onClick={() => removeQuestion(index)}
                              className="ml-2 px-2 py-1 bg-red-500 text-white rounded-lg"
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                        <button
                          type="button"
                          onClick={addQuestion}
                          className="px-4 py-2 bg-blue-500 text-white rounded-lg mt-2"
                        >
                          Add Question
                        </button>
                      </>
                    )}
                  </div>
                  <label className="block mb-2 text-sm text-gray-500 mt-4">
                    Custom Interview Message
                  </label>
                  <textarea
                    name="customMessage"
                    value={formData.customMessage}
                    onChange={handleCustomMessage}
                    className="w-full p-2 border rounded-lg"
                    placeholder="Enter custom message for the applicant..."
                  />
                  <div className="flex justify-end mt-4">
                    <button
                      type="submit"
                      className="px-6 py-2 bg-orange-500 text-white rounded-lg"
                    >
                      {loading ? <Spinner /> : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
        <div className={`md:w-2/5 p-4 border rounded-lg bg-white shadow-lg`}>
          <h1 className="mb-4 font-semibold text-lg">Applicants</h1>
          {applicationData?.map((eachApplicant, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  handleSelect(index);
                }}
                className={`flex mb-2 hover:bg-gray-100 hover:font-semibold ${
                  currentApplicant === index ? "bg-orange-100" : "bg-white"
                } cursor-pointer items-center justify-between p-2`}
              >
                <h2>Name: {`${eachApplicant.applicant[0]?.firstName} ${eachApplicant?.applicant[0]?.lastName}`}</h2>
                <h2>Email: {`${eachApplicant.applicant[0]?.email}`}</h2>
                <h3>{jobDetails.jobTitle}</h3>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex justify-center mt-6">
        {currentApplicant > 0 && (
          <button
            onClick={() => handleSelect(currentApplicant - 1)}
            className="p-2 border rounded-l-lg bg-white text-gray-500 border-gray-300"
          >
            <FaLessThan />
          </button>
        )}
        <button
          onClick={() => handleSelect(currentApplicant + 1)}
          className="p-2 border rounded-r-lg bg-white text-gray-500 border-gray-300"
        >
          <FaGreaterThan />
        </button>
      </div>
      <PDFPreviewModal
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
        }}
        base64Data={data?.applications[currentApplicant]?.resume || ""}
      />
      <FooterComponent />
    </div>
  );
}

export default ApplicantionStatus;















































































































// import Essential from "../../assets/Images/companyName.svg";
// import { FaGreaterThan, FaLessThan } from "react-icons/fa";
// import Header from "../../component/Header";
// import FooterComponent from "../../component/Footer";
// import { useState } from "react";
// import { useParams } from "react-router-dom";
// import { BsEye } from "react-icons/bs";
// import { useSelector, useDispatch } from "react-redux";
// import { useFetchData } from "../../hooks/useFtechData";
// import { APPLICATION_API,
//   INTERVIEW_API,
//   JOB_URL,
//   EMAILJS_SERVICE_ID,
//   EMAILJS_TEMPLATE_ID,
//   EMAILJS_PRIVATE_KEY, } from "../../resources/resource";

// import PDFPreviewModal from "../../component/pdf/CvPreview";
// import { useMakeRequest } from "../../hooks/useMakeRequest";
// import { Spinner } from "flowbite-react";
// import { toast } from "sonner";
// import emailjs from "@emailjs/browser"; // Import EmailJS

// // import { getAllApplicant } from "./data";

// function ApplicantionStatus() {
//   const [currentApplicant, setCurrentApplicant] = useState(0);
//   const { jobId } = useParams();
//   const [loading, setLoading] = useState(false);
//   // const dispatch = useDispatch()
//   const currentUserDetails = useSelector((state) => state.user.currentUser);
//   const currentApplication = useSelector(
//     (state) => state.currentApplication.currentApplication
//   );
//   const currentUserId = currentUserDetails?._id || "";
//   const makeRequest = useMakeRequest();

//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [interviewData, setInterviewData] = useState({
//     job: jobId,
//     additionalInformation: "N/A",
//   });

//   const [formData, setFormData] = useState({
//     status: "Rejected",
//     customMessage: "",
//     reasonForRejection: "",
//   });

//   const [notificationData, setNotificationData] = useState({
//     sender: currentUserId,
//     message: "Sorry",
//   });

//   const [jobDetails, setJobDetails] = useState({});
//   const [applications, setApplications] = useState([]);
//   const [appResponse, setAppResponse] = useState("Rejected");
//   const [allApplicant, setAllApplicant] = useState([]);

//   // const fetchJobURL = `${process.env.REACT_APP_API_URL}job/getAJob`;
//   // const updateApplication = `${process.env.REACT_APP_API_URL}application/updateApplication`;
//   // const createNotificationUrl = `${process.env.REACT_APP_API_URL}notification/createNotification`;
//   // const createInterviewURL = `${process.env.REACT_APP_API_URL}interview/createInterview`;

//   const {
//     data,
//     loading: dataLoading,
//     refetch,
//   } = useFetchData(JOB_URL + `/getAJob/${jobId}`);
//   const {
//     data: applicationData,
//     loading: applicationLoading,
//     refetch: applicationRefetch,
//   } = useFetchData(APPLICATION_API + `/getApplicationByJobId/${jobId}`);

//   const handleSelect = (newIndex) => {
//     setCurrentApplicant(newIndex);
//     setInterviewData({
//       ...interviewData,
//       application: currentApplication[currentApplicant]?._id,
//     });
//   };


//   ///send email
//     const sendEmail = (recipientEmail, subject, message) => {
//     const emailParams = {
//       service_id: 'service_afegl1k',
//       template_id: 'template_04rydyq',
//       user_id: 'zIaKhbr0CeuU_xR6n',
//       template_params: {
//         recipient_email: recipientEmail,
//         from_name: data?.employerName || "E-Job Portal",
//         message: message,
//       },
//     };

//     emailjs.send(
//       'service_afegl1k',
//       'template_04rydyq',
//       emailParams.template_params,
//       'zIaKhbr0CeuU_xR6n'
//     )
//       .then(() => {
//         toast.success("Email sent successfully!");
//       })
//       .catch((error) => {
//         console.log("Email send error:", error);
//         toast.error("Failed to send email.");
//       });
//   };


//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   setLoading(true);
//   //   const applicationId = data?.applications[currentApplicant]?._id;
//   //   try {
//   //     if (appResponse === "Scheduled") {
//   //       setInterviewData({
//   //         ...interviewData,
//   //         application: data?.applications[currentApplicant]?._id,
//   //       });
//   //       makeRequest(
//   //         INTERVIEW_API + `/createInterview`,
//   //         "POST",
//   //         interviewData,
//   //         (data) => {
//   //           refetch();
//   //         },
//   //         (error) => {
//   //           console.log(error);
//   //         },
//   //         () => {
//   //           console.log();
//   //         }
//   //       );
//   //     }
//   //     makeRequest(
//   //       APPLICATION_API + `/updateApplication/${applicationId}`,
//   //       "PUT",
//   //       formData,
//   //       () => {
//   //         refetch();
//   //       },
//   //       (error) => {
//   //         console.log(error);
//   //       },
//   //       () => {
//   //         setLoading(false);
//   //       }
//   //     );
//   //   } catch (error) {
//   //     console.error("Error updating application:", error);
//   //   }
//   // };

//     const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const applicationId = data?.applications[currentApplicant]?._id;
//     const applicantEmail = data?.numberOfApplicant[currentApplicant]?.email;

//     try {
//       if (appResponse === "Scheduled") {
//         setInterviewData({
//           ...interviewData,
//           application: data?.applications[currentApplicant]?._id,
//         });
//         makeRequest(
//           INTERVIEW_API + `/createInterview`,
//           "POST",
//           interviewData,
//           (data) => {
//             refetch();
//             // Custom message for scheduled interview including details
//             const interviewDetails = `Interview Scheduled:\nType: ${interviewData.typeOfInterview || "N/A"}\nLocation: ${interviewData.interviewLocation || "N/A"}\nDate: ${interviewData.interviewDate || "N/A"}\nTime: ${interviewData.interviewTime || "N/A"}\nAdditional Info: ${interviewData.additionalInformation}\n\n${formData.customMessage || "We look forward to seeing you!"}`;
//             sendEmail(applicantEmail, "Interview Scheduled", interviewDetails);
//           },
//           (error) => {
//             console.log(error);
//           },
//           () => {
//             console.log();
//           }
//         );
//       } else if (appResponse === "Rejected") {
//         // Custom message for rejection including reason
//         const rejectionMessage = `Application Rejected:\nReason: ${formData.reasonForRejection || "No reason provided"}\n\n${formData.customMessage || "We regret to inform you that your application was not successful."}`;
//         sendEmail(applicantEmail, "Application Rejected", rejectionMessage);
//       }

//       makeRequest(
//         APPLICATION_API + `/updateApplication/${applicationId}`,
//         "PUT",
//         formData,
//         () => {
//           refetch();
//         },
//         (error) => {
//           console.log(error);
//         },
//         () => {
//           setLoading(false);
//         }
//       );
//     } catch (error) {
//       console.error("Error updating application:", error);
//     }
//   };


//   const handleResponse = (value) => {
//     if (value === "Rejected") {
//       setNotificationData((prevNotify) => ({
//         ...prevNotify,
//         message: "Sorry",
//         recipient: data?.numberOfApplicant[currentApplicant]._id,
//         application: data?.applications[currentApplicant]._id,
//       }));
//     } else {
//       setNotificationData((prevNotify) => ({
//         ...prevNotify,
//         message: "Congratulations",
//         recipient: data?.numberOfApplicant[currentApplicant]?._id,
//         application: data?.applications[currentApplicant]?._id,
//       }));
//       setFormData((prevData) => ({ ...prevData, reasonForRejection: null }));
//     }
//     setFormData((prevData) => ({ ...prevData, status: value }));
//     setAppResponse(value);
//   };

//   const handleReason = (e) => {
//     const value = e.target.value;
//     setFormData({ ...formData, [e.target.name]: value });
//   };


//     const handleCustomMessage = (e) => {
//     const value = e.target.value;
//     setFormData({ ...formData, customMessage: value });
//   };

//   const handleInterviewData = (key, value) => {
//     setInterviewData({ ...interviewData, [key]: value });
//   };

//   return (
//     <div className="container mx-auto p-4 text-sm pt-16 sm:pt-20">
//       <Header darkMode={true} />
//       <div className="flex flex-col md:flex-row md:space-x-6">
//         <div className="md:w-3/5 p-4 border rounded-lg bg-white shadow-lg">
//           {/* ------------Logo area---------------- */}
//           <div className="flex justify-between items-center mb-4">
//             <img
//               className="w-40"
//               src={data?.employer?.avatar || Essential}
//               alt="company logo"
//             />
//             {/* <img className="w-24" src={Logo} alt="company logo" /> */}
//           </div>

//           <h1 className="text-2xl font-semibold mb-2">{jobDetails.jobTitle}</h1>
//           <p className="text-gray-600">{data?.employerName}</p>
//           <p className="text-gray-600 mb-4">{data?.state}</p>

//           {/* ------------Job details section----------------- */}
//           <div className="mb-4">
//             <h3 className="font-medium">Job Details</h3>
//             <div className="mt-2">
//               <span className="px-2 py-1 bg-gray-200 rounded-2xl mr-2">
//                 {data?.jobType}
//               </span>
//               <span className="px-2 py-1 bg-gray-200 rounded-2xl">
//                 {data?.salary}
//               </span>
//             </div>
//             <div className="pt-4">
//               <p>{data?.jobSummary}</p>
//             </div>
//             <div className="mt-4 bg-gray-100 p-4 rounded-lg">
//               <ul className="list-disc pl-4">
//                 {data?.jobDescription
//                   ? data.jobDescription.map((eachDescription, index) => (
//                       <li key={index}>{eachDescription}</li>
//                     ))
//                   : null}
//               </ul>
//             </div>

//             {/* ---------------------cover letter section-------------- */}
//             <div className="my-6">
//               <h3 className="text-xl font-semibold mb-2">
//                 Why should we hire you
//               </h3>
//               <div className="border p-3 rounded-lg bg-gray-50">
//                 <span className="block text-gray-500 mb-2">Cover Letter</span>
//                 <p>{data?.applications[currentApplicant]?.coverLetter || ""}</p>
//               </div>
//             </div>


//             {/* ------------Quetionaire section------------- */}
//             <div className="flex flex-col space-y-4 w-full">
//               {data?.additionalInterviewQuestion &&
//                 data?.applications[
//                   currentApplicant
//                 ].additionalQuestionResponse.map((eachResponse, index) => (
//                   <div className="w-full" key={index}>
//                     <h3 className="capitalize mb-2">{eachResponse.question}</h3>
//                     <span className="block p-2 border bg-gray-200 rounded-lg">
//                       {eachResponse.response}
//                     </span>
//                   </div>
//                 ))}
//             </div>

//             {/* -----------------Resume view section------------------- */}
//             <div className="my-4">
//               <h2 className="text-lg font-semibold mb-2">Resume/CV</h2>
//               <button
//                 onClick={() => {
//                   setIsModalOpen(true);
//                 }}
//                 className="flex items-center p-2 rounded bg-gray-400 text-white w-full justify-between"
//               >
//                 {data?.applications[currentApplicant]?.resume?.split(";")[0] ||
//                   ""}
//                 <BsEye />
//               </button>
//             </div>

//             {/* ----------Application action ----------- */}
//             <div className="flex justify-between">
//               <button
//                 onClick={() => {
//                   handleResponse("Rejected");
//                 }}
//                 className={`w-1/2 px-4 py-2 border rounded-l-lg ${
//                   appResponse === "Rejected"
//                     ? "bg-orange-500 text-white border-orange-400"
//                     : "bg-white text-gray-500 border-gray-300"
//                 }`}
//               >
//                 Reject
//               </button>
//               <button
//                 onClick={() => {
//                   handleResponse("Scheduled");
//                 }}
//                 className={`w-1/2 px-4 py-2 border rounded-r-lg ${
//                   appResponse === "Scheduled"
//                     ? "bg-orange-500 text-white border-orange-400"
//                     : "bg-white text-gray-500 border-gray-300"
//                 }`}
//               >
//                 Set for interview
//               </button>
//             </div>
//             {/* {appResponse === "Rejected" && (
//               <div className="my-4">
//                 <form action="">
//                   <label className="block mb-2 text-sm text-gray-500">
//                     Reason for rejection
//                   </label>
//                   <textarea
//                     name="reasonForRejection"
//                     value={formData.reasonForRejection}
//                     onChange={handleReason}
//                     className="w-full p-2 border rounded-lg"
//                   />
//                   <button
//                     onClick={handleSubmit}
//                     className="px-6 py-2 bg-orange-500 text-white rounded-lg"
//                   >
//                     Submit
//                   </button>
//                 </form>
//               </div>
//             )}
//             {appResponse === "Scheduled" && (
//               <div className="p-4 border rounded-lg bg-white shadow-lg mt-6">
//                 <h2 className="text-lg font-semibold mb-4">
//                   Schedule an Interview
//                 </h2>
//                 <form onSubmit={handleSubmit}>
//                   <div className="space-y-4">
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">
//                         Interview Type
//                       </label>
//                       <select
//                         value={interviewData.typeOfInterview}
//                         onChange={(e) =>
//                           handleInterviewData("typeOfInterview", e.target.value)
//                         }
//                         className="border rounded-lg p-2"
//                       >
//                         <option value="">Select Interview Type</option>
//                         <option value="Physical">Physical</option>
//                         <option value="Virtual">Virtual</option>
//                       </select>
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">
//                         Location
//                       </label>
//                       <input
//                         type="text"
//                         value={interviewData.interviewLocation}
//                         onChange={(e) =>
//                           handleInterviewData(
//                             "interviewLocation",
//                             e.target.value
//                           )
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">Date</label>
//                       <input
//                         type="date"
//                         value={interviewData.interviewDate}
//                         onChange={(e) =>
//                           handleInterviewData("interviewDate", e.target.value)
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">Time</label>
//                       <input
//                         type="time"
//                         value={interviewData.interviewTime}
//                         onChange={(e) =>
//                           handleInterviewData("interviewTime", e.target.value)
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">
//                         Additional Information
//                       </label>
//                       <input
//                         type="text"
//                         value={interviewData.additionalInformation}
//                         onChange={(e) =>
//                           handleInterviewData(
//                             "additionalInformation",
//                             e.target.value
//                           )
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <div className="flex justify-end mt-4">
//                       <button
//                         type="submit"
//                         className="px-6 py-2 bg-orange-500 text-white rounded-lg"
//                       >
//                         {loading ? <Spinner /> : "Submit"}
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             )} */}


//                {appResponse === "Rejected" && (
//               <div className="my-4">
//                 <form action="">
//                   <label className="block mb-2 text-sm text-gray-500">
//                     Reason for rejection
//                   </label>
//                   <textarea
//                     name="reasonForRejection"
//                     value={formData.reasonForRejection}
//                     onChange={handleReason}
//                     className="w-full p-2 border rounded-lg"
//                   />
//                   <label className="block mb-2 text-sm text-gray-500 mt-4">
//                     Custom Rejection Message
//                   </label>
//                   <textarea
//                     name="customMessage"
//                     value={formData.customMessage}
//                     onChange={handleCustomMessage}
//                     className="w-full p-2 border rounded-lg"
//                     placeholder="Enter custom message for the applicant..."
//                   />
//                   <button
//                     onClick={handleSubmit}
//                     className="px-6 py-2 bg-orange-500 text-white rounded-lg mt-4"
//                   >
//                     Submit
//                   </button>
//                 </form>
//               </div>
//             )}
//             {appResponse === "Scheduled" && (
//               <div className="p-4 border rounded-lg bg-white shadow-lg mt-6">
//                 <h2 className="text-lg font-semibold mb-4">
//                   Schedule an Interview
//                 </h2>
//                 <form onSubmit={handleSubmit}>
//                   <div className="space-y-4">
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">
//                         Interview Type
//                       </label>
//                       <select
//                         value={interviewData.typeOfInterview}
//                         onChange={(e) =>
//                           handleInterviewData("typeOfInterview", e.target.value)
//                         }
//                         className="border rounded-lg p-2"
//                       >
//                         <option value="">Select Interview Type</option>
//                         <option value="Physical">Physical</option>
//                         <option value="Virtual">Virtual</option>
//                       </select>
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">
//                         Location
//                       </label>
//                       <input
//                         type="text"
//                         value={interviewData.interviewLocation}
//                         onChange={(e) =>
//                           handleInterviewData(
//                             "interviewLocation",
//                             e.target.value
//                           )
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">Date</label>
//                       <input
//                         type="date"
//                         value={interviewData.interviewDate}
//                         onChange={(e) =>
//                           handleInterviewData("interviewDate", e.target.value)
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">Time</label>
//                       <input
//                         type="time"
//                         value={interviewData.interviewTime}
//                         onChange={(e) =>
//                           handleInterviewData("interviewTime", e.target.value)
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <div className="flex flex-col">
//                       <label className="mb-2 text-sm text-gray-500">
//                         Additional Information
//                       </label>
//                       <input
//                         type="text"
//                         value={interviewData.additionalInformation}
//                         onChange={(e) =>
//                           handleInterviewData(
//                             "additionalInformation",
//                             e.target.value
//                           )
//                         }
//                         className="border rounded-lg p-2"
//                       />
//                     </div>
//                     <label className="block mb-2 text-sm text-gray-500 mt-4">
//                       Custom Interview Message
//                     </label>
//                     <textarea
//                       name="customMessage"
//                       value={formData.customMessage}
//                       onChange={handleCustomMessage}
//                       className="w-full p-2 border rounded-lg"
//                       placeholder="Enter custom message for the applicant..."
//                     />
//                     <div className="flex justify-end mt-4">
//                       <button
//                         type="submit"
//                         className="px-6 py-2 bg-orange-500 text-white rounded-lg"
//                       >
//                         {loading ? <Spinner /> : "Submit"}
//                       </button>
//                     </div>
//                   </div>
//                 </form>
//               </div>
//             )}
//           </div>
//         </div>
//         <div className={`md:w-2/5 p-4 border $ rounded-lg bg-white shadow-lg`}>
//           <h1 className="mb-4 font-semibold text-lg">Applicants</h1>
//           {applicationData?.map((eachApplicant, index) => {
//             return (
//               <div
//                 key={index}
//                 onClick={() => {
//                   handleSelect(index);
//                 }}
//                 className={`flex mb-2 hover:bg-gray-100 hover:font-semibold ${
//                   currentApplicant === index ? "bg-orange-100" : "bg-white"
//                 } cursor-pointer items-center justify-between p-2`}
//               >
//                 <h2>Name: {`${eachApplicant.applicant[0]?.firstName} ${eachApplicant?.applicant[0]?.lastName}`}</h2>
//                 <h2>Email: {`${eachApplicant.applicant[0]?.email}`}</h2>
//                 <h3>{jobDetails.jobTitle}</h3>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       <div className="flex justify-center mt-6">
//         {currentApplicant > 0 && (
//           <button
//             onClick={() => handleSelect(currentApplicant - 1)}
//             className="p-2 border rounded-l-lg bg-white text-gray-500 border-gray-300"
//           >
//             <FaLessThan />
//           </button>
//         )}
//         <button
//           onClick={() => handleSelect(currentApplicant + 1)}
//           className="p-2 border rounded-r-lg bg-white text-gray-500 border-gray-300"
//         >
//           <FaGreaterThan />
//         </button>
//       </div>
//       <PDFPreviewModal
//         isOpen={isModalOpen}
//         onClose={() => {
//           setIsModalOpen(false);
//         }}
//         base64Data={data?.applications[currentApplicant]?.resume || ""}
//       />
//       <FooterComponent />
//     </div>
//   );
// }

// export default ApplicantionStatus;
























































